import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {CkmService} from "../../../services/ckm.service";


@Component({
  selector: 'app-ckm-simulation',
  templateUrl: './ckm-simulation.component.html',
  styleUrls: ['./ckm-simulation.component.scss']
})
export class CkmSimulationComponent implements OnInit {
  simulationId: string;
  simulation = null;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private ckmService: CkmService,
    ) {}

  ngOnInit(): void {
    this.retrieveSimulation();
  }

  /**
   * Recupera la simulation in base all'id presente nella route.
   * Simuliamo la chiamata con un setTimeout.
   */
  retrieveSimulation(): void {
    this.loading = true;
    this.simulationId = this.route.snapshot.paramMap.get('simulation-id');
    this.ckmService.getCkmSimulationDetails(this.simulationId, (response) => {
      this.loading = false;
      this.simulation = response;
    });
  }
}
